import flatpickr from '../../../node_modules/flatpickr';
import { Portuguese } from '../../../node_modules/flatpickr/dist/l10n/pt.js';

class Form {
  constructor() {
    flatpickr('.js-datetimepicker', {
      enableTime: true,
      time_24hr: true,
      dateFormat: 'd/m/Y H:i',
      locale: Portuguese,
      minDate: 'today',
      disableMobile: true
    });
  }
}

export default Form;
